import { ColumnDefAndHeader, ViewSortModel } from '../../models/datacenter-aggrid-view';

export class ColumnAggregator {
	readonly pinnedColumns: ColumnDefAndHeader[] = [];
	readonly scrollableColumns: ColumnDefAndHeader[] = [];
	allColumns: ColumnDefAndHeader[] = [];
	readonly sortColumnMap = new Map<ColumnDefAndHeader, 'asc' | 'desc'>();
	readonly sortColumnList: ColumnDefAndHeader[] = [];

	constructor(allColumns: ColumnDefAndHeader[]) {
		this.allColumns = allColumns;
	}

	addVisibleColumn(column: ColumnDefAndHeader) {
		if (!Number.isNaN(Number(column.colId))) {
			return;
		}
		if (column.pinned) {
			this.pinnedColumns.push(column);
		} else {
			this.scrollableColumns.push(column);
		}
		const index = this.allColumns.findIndex(value => value.colId === column.colId);
		this.allColumns.splice(index, 1);
	}

	getColumnsToShow() {
		for (const pinnedColumn of this.pinnedColumns) {
			pinnedColumn.pinned = 'left';
		}

		for (const scrollableColumn of this.scrollableColumns) {
			scrollableColumn.pinned = undefined;
		}

		const pinnedColumns = this.pinnedColumns.map(value => ({ colId: value.colId, pinned: value.pinned }));
		const scrollableColumns = this.scrollableColumns.map(value => ({ colId: value.colId }));

		return [...pinnedColumns, ...scrollableColumns];
	}

	addSortColumn(sortModel: ViewSortModel) {
		if (!Number.isNaN(Number(sortModel.colId))) {
			return;
		}
		const index = this.allColumns.findIndex(value => value.colId === sortModel.colId);
		const item = this.allColumns[index];
		this.sortColumnList.push(item);
		this.sortColumnMap.set(item, sortModel.sort);
	}
}
